<template>
  <div
    style="scrollbar-gutter: stable"
    :style="sideFilters && { width: 'clamp(16.25rem, 25%, 22.5rem)' }"
  >
    <slot name="title" />
    <filter-display
      v-bind="{ filters, filtersQuery, currency, sideFilters }"
      class="b-b b-grey-80 py-4"
      :max-collapsed-rows="{ sm: 2, md: 1, lg: 2 }"
      @clear="$emit('clear')"
      @remove="$emit('remove', $event)"
    />
    <filter-pickup
      v-if="pickupFilters"
      class="b-b b-grey-80 py-4"
      :model-value="storeFilterState"
      @update:model-value="$emit('changeStore', $event)"
    />
    <vf-accordion
      v-if="sortOptions?.length"
      :open="!!openedSections?.sortOptions"
      :title="$t.sort"
      variant="aligned"
      @update:open="(val) => toggle('sortOptions', val)"
    >
      <div class="f-col gap-2 pb-4">
        <vf-radio
          v-for="{ value, label } in sortOptions"
          :key="value"
          :model-value="sortState"
          name="sort"
          :value
          @update:model-value="$emit('sort', $event!)"
        >
          {{ label }}
        </vf-radio>
      </div>
    </vf-accordion>
    <template v-if="Object.keys(filters)?.length">
      <vf-accordion
        v-for="(filter, code) in filters"
        :key="code"
        :open="!!openedSections?.[code]"
        :title="filter.label"
        variant="aligned"
        @update:open="(val) => toggle(code, val)"
      >
        <filter-options
          class="pb-4"
          :code
          :currency
          :filter
          :loading
          :model-value="filters[code].selected"
          @update:model-value="$emit('change', { code: `${code}`, selected: $event! })"
        />
      </vf-accordion>
    </template>
    <product-list-skeleton v-else-if="loading" />
  </div>
</template>

<script lang="ts" setup>
import type { SortType } from '#types/config/pages/plp'
import type { FiltersMap } from '#types/filters'

defineProps<{
  sideFilters?: boolean
  currency?: string
  loading?: boolean
  filters: FiltersMap
  filtersQuery?: Record<string, string[]>
  total: number
  pickupFilters: boolean
  sortOptions?: { value: SortType, label: string }[]
  sortState?: string
  storeFilterState?: string
}>()

defineEmits<{
  clear: []
  remove: [payload: { code: string, id: string }]
  change: [payload: { code: string, selected: string[] }]
  changeStore: [payload?: string]
  sort: [payload: string]
}>()

defineSlots<{
  title: () => void
}>()
const openedSections = defineModel<Partial<Record<string, boolean>>>('openedSections', {
  default: () => ({})
})
const toggle = (code: string | number, isOpen?: boolean | string) => {
  openedSections.value = {
    ...openedSections.value,
    [code]: !!isOpen
  }
}
</script>
